import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from 'axios'

function Footer() {
  const [links, setLinks] = useState({ facebook_url:'', instagram_url:'', twitter_url:'', email:'', phone:'' })
  useEffect(() => {
    (async () => {
      try{
        const { data } = await axios.get('/api/site/settings/')
        setLinks(data || {})
      }catch(e){
        // ignore errors; leave defaults
      }
    })()
  }, [])
  return (
    <footer className="ws-footer">
      <Container>
        <Row className="gy-4">
          <Col md={4}>
            <div className="ws-footer-title">WigsNStuff</div>
            <div className="ws-muted">
              Premium quality wigs for every style and occasion. Transform your look with
              confidence.
            </div>
            <div className="mt-3 d-flex gap-3">
              <a href={links.facebook_url || '#'} target="_blank" rel="noreferrer"><i className="fab fa-facebook"></i></a>
              <a href={links.instagram_url || '#'} target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
              <a href={links.twitter_url || '#'} target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a>
              <a href={links.email ? `mailto:${links.email}` : '#'}><i className="far fa-envelope"></i></a>
            </div>
          </Col>
          <Col md={2}>
            <div className="ws-footer-title">Shop</div>
            <ul className="list-unstyled m-0">
              <li><Link to="/shop">All Products</Link></li>
              <li><Link to="/new">New Arrivals</Link></li>
              <li><a href="#">Best Sellers</a></li>
              <li><a href="#">Sale</a></li>
            </ul>
          </Col>
          <Col md={3}>
            <div className="ws-footer-title">Customer Care</div>
            <ul className="list-unstyled m-0">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><a href="#">Shipping Info</a></li>
              <li><a href="#">Returns</a></li>
              <li><Link to="/faq">FAQ</Link></li>
            </ul>
          </Col>
          <Col md={3}>
            <div className="ws-footer-title">Company</div>
            <ul className="list-unstyled m-0">
              <li><Link to="/about">About Us</Link></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-center">
            © {new Date().getFullYear()} WigsNStuff. All rights reserved.
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer